/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { PurchasePriceListFragment } from '../../../../generated/graphql'

export function isPurchasePriceListFragment(
  value: any,
): value is PurchasePriceListFragment {
  return value?.__typename === 'PurchasePriceList'
}
